import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  forgotPasswordApi,
  getChangePasswordTokenApi,
  GetEmailResendOtpApi,
  loginApi,
  refreshTokenApi,
  doEmailLoginOtpApi,
  sendEmailOtpApi,
  signUpApi,
  socialSignUpApi,
  verifyTokenApi,
} from "../api/auth-api/auth-api";

// Async thunks for API calls
export const sendEmailOtp = createAsyncThunk(
  "authEmail/sendEmailOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await sendEmailOtpApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const verifyEmailOtp = createAsyncThunk(
  "authEmail/verifyEmailOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await doEmailLoginOtpApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const resendEmailOtp = createAsyncThunk(
  "authEmail/resendEmailOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetEmailResendOtpApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const forgotPassword = createAsyncThunk(
  "authEmail/forgotPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await forgotPasswordApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const signUp = createAsyncThunk(
  "authEmail/signUp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await signUpApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const socialSignUp = createAsyncThunk(
  "authEmail/socialSignUp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await socialSignUpApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const refreshToken = createAsyncThunk(
  "authEmail/refreshToken",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await refreshTokenApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const login = createAsyncThunk(
  "authEmail/login",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await loginApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const verifyToken = createAsyncThunk(
  "authEmail/verifyToken",
  async (_, { rejectWithValue }) => {
    try {
      const response = await verifyTokenApi();
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const getChangePasswordToken = createAsyncThunk(
  "authEmail/getChangePasswordToken",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getChangePasswordTokenApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);


// Initial state
const initialState = {
  UserSessionPayload: {
    isTokenExpired: false,
    loginTime: "",
    userId: "",
  },
  otp: "",
  loading: false,
  resentloading: false,
  error: null,
  isOtpVerified: false,
  isAuthenticated: false,
  authResponse: null,
};

// Slice definition
const EmailAuthSlice = createSlice({
  name: "authEmail",
  initialState,
  reducers: {
    resetOtp: (state) => {
      state.otp = "";
      state.isOtpVerified = false;
      state.error = null;
    },
    setUserSessionPayload: (state, action) => {
      console.log("ththrrnrh", action.payload);
      state.UserSessionPayload = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendEmailOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendEmailOtp.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(sendEmailOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(verifyEmailOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyEmailOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.isOtpVerified = true;
      })
      .addCase(verifyEmailOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(resendEmailOtp.pending, (state) => {
        state.resentloading = true;
      })
      .addCase(resendEmailOtp.fulfilled, (state) => {
        state.resentloading = false;
      })
      .addCase(resendEmailOtp.rejected, (state, action) => {
        state.resentloading = false;
        state.error = action.error.message;
      })
      .addCase(forgotPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.authResponse = action.payload;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.errorMessage || action.error.message;
      })
      .addCase(signUp.pending, (state) => {
        state.loading = true;
      })
      .addCase(signUp.fulfilled, (state, action) => {
        state.loading = false;
        state.authResponse = action.payload;
      })
      .addCase(signUp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.errorMessage || action.error.message;
      })
      .addCase(socialSignUp.pending, (state) => {
        state.loading = true;
      })
      .addCase(socialSignUp.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.authResponse = action.payload;
      })
      .addCase(socialSignUp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.errorMessage || action.error.message;
      })
      .addCase(refreshToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(refreshToken.fulfilled, (state, action) => {
        state.loading = false;
        state.authResponse = action.payload;
      })
      .addCase(refreshToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.errorMessage || action.error.message;
      })
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.authResponse = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.errorMessage || action.error.message;
      })
      .addCase(verifyToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyToken.fulfilled, (state, action) => {
        state.loading = false;
        state.authResponse = action.payload;
      })
      .addCase(verifyToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.errorMessage || action.error.message;
      })
      .addCase(getChangePasswordToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(getChangePasswordToken.fulfilled, (state, action) => {
        state.loading = false;
        state.authResponse = action.payload;
      })
      .addCase(getChangePasswordToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.errorMessage || action.error.message;
      });
  },
});

export const { setUserSessionPayload } = EmailAuthSlice.actions;
export default EmailAuthSlice.reducer;
